import { useOUserSettingsStore } from '@/stores/use-user-settings-store';
import { useOSettings } from './use-settings';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

export function useHHomepageLink() {
  const { oUserSettings } = storeToRefs(useOUserSettingsStore());
  const { workspaces_path } = useOSettings();

  return computed(() => {
    if (oUserSettings.value?.settings?.defaultpage?.type === 'workspace') {
      return `${workspaces_path?.value ?? ''}/${oUserSettings.value?.settings?.defaultpage?.value ?? ''}`;
    } else if (oUserSettings.value?.settings?.defaultpage?.type === 'allworkspaces') {
      // Fallback to app route if `workspaces_path` is not defined
      return workspaces_path?.value ?? '/';
    } else if (oUserSettings.value?.settings?.defaultpage?.type === 'lastworkspace') {
      return `${workspaces_path?.value ?? ''}/${oUserSettings.value?.lastworkspace ?? ''}`;
    } else {
      return '/';
    }
  });
}
